import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export const useFunctions = (enabled: boolean) => {
  const plantCode = useUrlParam('plantCode')
  return useSettingsQuery('functions', [plantCode], {enabled})
}
